module.exports = __webpack_public_path__ + "img/WALK-COMFORT-05.de8e7a82.png";